module.exports = __webpack_public_path__ + "static/media/parallel-black.38c028c2.svg";